module.exports = "<p>Here is process we'll follow.</p>\n<div class=\"progressStepsContainer\">\n<as-progress-steps as-progress-steps=\"$ctrl.asProgressSteps\" > </as-progress-steps>\n</div>\n<div class=\"padding-t-20\">\n<p>Copy the entire license below (including dashes). Go to your Appspace Console and paste the license there to apply this license to your on-prem server.</p>\n<as-copy text=\"$ctrl.payload\" hidecopybutton=\"$ctrl.hidecopybutton\"></as-copy></div>";


//////////////////
// WEBPACK FOOTER
// ./modules/license/features/license-deactivate-license/licenseDeactivateLicense.component.html
// module id = 553
// module chunks = 0